// Deferred loader for the AI Concierge widget.
// Only imports & mounts the widget after the browser is idle (post-LCP)
// or after 3s, whichever comes first. This keeps the initial bundle small
// and avoids blocking Time-to-Interactive on the home page.
import React, { useEffect, useState, Suspense, lazy } from "react";

const ConciergeInner = lazy(() =>
  import("./Layout").then((m) => ({ default: m.ConciergeWidget }))
);

export default function DeferredConcierge() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const start = () => setReady(true);
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(start, { timeout: 3000 });
      return () => window.cancelIdleCallback && window.cancelIdleCallback(id);
    }
    const t = setTimeout(start, 2500);
    return () => clearTimeout(t);
  }, []);
  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <ConciergeInner />
    </Suspense>
  );
}
